<template>
  <div class="myHeader">
    <div class="hl">
      <!-- logo -->
      <router-link to="/home">
        <img class="logo_img" :src="webConfig.logoFull || ''" v-if="webConfig" />
      </router-link>
      <!-- 园区切换 -->
<!--      <park_switch v-if="parkInfo" />-->
    </div>
    <div class="hc">
      <div class="left_box">
        <!-- 菜单 -->
        <div class="nav_box" v-if="!showSearch">
          <router-link :class="{router_link_active:$route.path==='/home'}" to="/home">首页</router-link>
          <router-link
            :class="{router_link_active:$route.meta.exp.indexOf('办公空间-')>-1}"
            to="/office_space"
          >办公空间</router-link>
          <router-link
            :class="{router_link_active:$route.meta.exp.indexOf('园区-')>-1}"
            to="/investment_info"
          >孵化园区</router-link>
          <router-link
            :class="{router_link_active:$route.path.indexOf('supermarket')>-1}"
            to="/supermarket"
          >科技服务</router-link>
          <router-link
            :class="{router_link_active:$route.path.indexOf('achievement')>-1}"
            to="/achievement"
          >成果中心</router-link>
          <router-link
            :class="{router_link_active:$route.path.indexOf('eight_min')>-1}"
            to="/eight_min"
          >路演创赛</router-link>
          <router-link
            :class="{router_link_active:$route.path.indexOf('school')>-1}"
            to="/school"
          >科创培训</router-link>
          <router-link
            :class="{router_link_active:$route.path.indexOf('policy_info')>-1}"
            to="/policy_info"
          >政策直通车</router-link>
          <!-- 首选展示富文本 -->
          <template>
            <router-link
              :class="{router_link_active:$route.path.indexOf('about_us')>-1}"
              to="/about_us"
            >关于我们</router-link>
          </template>
        </div>
        <transition name="slide-fade">
          <div class="search_box" v-if="showSearch">
            <span class="my_icon close" @click="clearSearchText"></span>
            <input type="text" v-model="searchVal" placeholder="输入搜索的内容" @keyup.enter="search" />
            <i class="my_icon black_search" @click="search"></i>
          </div>

        </transition>
         <i class="my_icon black_search" v-if="!showSearch" @click="showSearch=true"></i>
        <!-- <i v-if="showNav" slot="suffix" class="el-input__icon el-icon-search" @click="showNav=false"></i>
        <div class="search_box" v-else>
          <i class="el-icon-close x" slot="prepend"  @click="showNav=true"></i>
          <el-input placeholder="请输入搜索内容" v-model="searchVal" @change="search">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
          </el-input>
        </div>-->
      </div>
    </div>
    <div class="hr">
      <div class="right_box">
        <dl>
          <template v-if="!info">
            <dd>
              <router-link to="/login" class="link">登录</router-link>
            </dd>
            <dd><span class="line">|</span></dd>
            <dd>
              <router-link to="/register" class="link">注册</router-link>
            </dd>
          </template>
          <template v-else>
            <dd>
              <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  <span>{{info.user_name}}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">个人中心</el-dropdown-item>
                  <el-dropdown-item command="b">账户设置</el-dropdown-item>
                  <el-dropdown-item command="c">退出登录</el-dropdown-item>
                  <el-dropdown-item command="d" divided>华转网</el-dropdown-item>
                  <el-dropdown-item command="e">8分钟路演</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </dd>
          </template>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import park_switch from "@/components/park/park_switch.vue";
export default {
  components: { park_switch },
  name: "myHeader",
  data() {
    return {
      searchVal: "",
      showSearch: false,
      islogin: true, //判断是否登录
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    parkInfo() {
      return this.$store.state.parkInfo;
    },
    webConfig() {
      return this.$store.state.webConfig;
    }
  },
  created(){
    this.common.getUserInfo(true);
    this.common.getParkInfo(true);
  },
  methods: {
    // 搜索框的清除按钮
    clearSearchText() {
      this.searchVal = "";
      this.showSearch = false;
    },
    /*下拉菜单*/
    handleCommand(com) {
      if (com === "a") {
        this.$router.push({
          name: "personal_center"
        });
      } else if (com === "b") {
        this.$router.push({
          name: "account_settings"
        });
      } else if (com === "c") {
        this.common.exitLogin();
      } else if (com === "d") {
        window.location.href = "https://www.sctcc.cn/#/";
      } else if (com === "e") {
        window.location.href = "http://8mins-show.com/#/home";
      }
    },
    search() {
      if (!this.searchVal) return;
      this.showSearch = false;
      this.$router.push({
        name: "search_result",
        query: {
          keyword: this.searchVal
        }
      });
    }
  }
};
</script>

<style lang="scss">
.myHeader {
  background: #fff;
  box-shadow: 0px 0px 14px 0px rgba(188, 208, 196, 0.35);
  display: flex;
  align-items: center;
  padding: 0 3%;
  min-width: 1200px;
  .hl {
    display: flex;
    align-items: center;
    .logo_img {
        width: 137px;
        height: 40px;
        object-fit: contain;
      }
  }
  .hc {
    flex:1;
    height: 64px;
    box-sizing: border-box;
    text-align: center;
    line-height: 64px;
    .left_box {
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      .nav_box {
        display: flex;
        margin-right: 10px;
        a {
          line-height: 64px;
          font-size: 16px;
          color: #666;
          margin-right: 24px;
        }
        a:last-child {
          margin-right: 0px;
        }
        .router_link_active {
          font-weight: bold;
          color: #3072f6;
          border-bottom: 2px #4c84ff solid;
        }
      }
      .search_box {
        display: flex;
        align-items: center;
        span {
          cursor: pointer;
        }
        i {
          cursor: pointer;
        }
        .icon {
          height: 18px;
          cursor: pointer;
          font-size: 18px;
          color: #abadb1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        input {
          border: none;
          border-left: 1px solid #878787;
          font-size: 14px;
          height: 18px;
          line-height: 18px;
          width: 530px;
          text-indent: 6px;
          margin: 0 10px;
          outline: none;
        }


      }
      .my_icon {
          background: url("~@/assets/img/common/icon.png") no-repeat;
          display: inline-block;
        }
       .my_icon.black_search {
          background-position: -5px -32px;
          width: 24px;
          height: 25px;
              margin-left: 10px;
        }
        .my_icon.close {
          background-position: -5px -62px;
          width: 19px;
          height: 19px;
        }
        .my_icon.white_search {
          background-position: -5px -84px;
          width: 19px;
          height: 19px;
        }
      .slide-fade-enter-active {
        transition: all 0.3s ease;
      }
      .slide-fade-leave-active {
        transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
      }
      .slide-fade-enter,
      .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
      }
    }
  }
  .hr {
    .right_box {
      display: flex;
      align-items: center;
      min-width: 133px;
      dl {
        display: flex;
        /*flex-wrap: wrap;*/
        dd {
          line-height: 16px;
          .link {
            color: #666;
            font-size: 16px;
            line-height: 34px;
          }
          .link:hover {
            color: #4c84ff;
          }
          .link.btn {
            display: inline-block;
            width: 80px;
            text-align: center;
            height: 34px;
            background: #4c84ff;
            border-radius: 4px;
            font-size: 16px;
            color: #ffffff;
            margin-left: 20px;
          }
          .line{
             color: #a1a7ac;
            font-size: 14px;
            margin:0 5px;
            line-height: 32px;
          }
        }
        dt {
          margin-left: 20px;
          .link {
            color: #000;
            font-size: 14px;
          }
          .link:hover {
            color: #ff733c;
          }
        }
      }
      .el-dropdown-link {
        span {
          max-width: 56px;
          overflow: hidden;
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  //登录
}
</style>
